<template>
  <div class="login">
    <div class="card">
      <div>
        <h3>Email</h3>
      </div>
      <div>
        <v-text-field
          v-model="email"
          placeholder="Email"
          outlined
          dense
          background-color="white"
        />
      </div>
      <div>
        <h3>Heslo</h3>
      </div>
      <div>
        <v-text-field
          v-model="password"
          type="password"
          placeholder="Heslo"
          outlined
          dense
          background-color="white"
        />
      </div>
      <hr style="border:solid #f9d71c;">

      <div class="mt-7">
        <v-btn
          color="#f9d71c"
          style="width:100%"
          @click="login"
        >
          <b>Přihlásit se</b>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login () {
      this.email = this.email.toLowerCase()
      if (this.email === 'groovefusionbattle@gmail.com' && this.password === 'Tbass1trejbi2covid19') {
        console.log('pes')
        this.$store.commit('login')
        this.$router.push('/admin/admindancers')
      }
    }
  }
}
</script>

<style scoped>
.login{
color: #f9d71c;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 93vh;
  background-color: black;
}
  .login h3{
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    font-size: 25px;
    text-align: start;
    padding-block: 5px;
}
.login .card{
    padding: 30px;
    width: 100%;
    max-width: 700px;
    border: solid 4px #f9d71c;
    border-radius: 10px;
}
</style>